import type { FC, ReactElement } from "react"

import { FileIconTemplate } from "./FileIconTemplate"

export type FileIconType = "default" | "doc" | "gif" | "jpeg" | "jpg" | "pdf" | "png"

interface FileIconProps {
  type: FileIconType
  className?: string
}

interface FileIconTemplateConfig {
  text: string
  stripeColor: string
}

const FILE_ICON_TYPE_TO_CONFIG: Record<Exclude<FileIconType, "png">, FileIconTemplateConfig> = {
  default: { text: "FILE", stripeColor: "#9E9E9E" }, // Gray
  doc: { text: "DOC", stripeColor: "#2196F3" }, // Blue
  gif: { text: "GIF", stripeColor: "#9C27B0" }, // Purple
  jpeg: { text: "JPEG", stripeColor: "#F57C00" }, // Orange
  jpg: { text: "JPG", stripeColor: "#F57C00" }, // Orange
  pdf: { text: "PDF", stripeColor: "#E53935" }, // Red
}

const PngIcon: FC<{ className?: string }> = ({ className }) => (
  <svg width='32' height='40' viewBox='0 0 32 40' fill='none' xmlns='http://www.w3.org/2000/svg' className={className}>
    <mask id='path-1-inside-1_78_39869' fill='white'>
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M4 0C2.89543 0 2 0.895431 2 2V38C2 39.1046 2.89543 40 4 40H30C31.1046 40 32 39.1046 32 38V12L20 0H4Z'
      />
    </mask>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4 0C2.89543 0 2 0.895431 2 2V38C2 39.1046 2.89543 40 4 40H30C31.1046 40 32 39.1046 32 38V12L20 0H4Z'
      fill='#F8F7F8'
    />
    <path
      d='M32 12H33V11.5858L32.7071 11.2929L32 12ZM20 0L20.7071 -0.707107L20.4142 -1H20V0ZM3 2C3 1.44772 3.44772 1 4 1V-1C2.34315 -1 1 0.343147 1 2H3ZM3 38V2H1V38H3ZM4 39C3.44772 39 3 38.5523 3 38H1C1 39.6569 2.34315 41 4 41V39ZM30 39H4V41H30V39ZM31 38C31 38.5523 30.5523 39 30 39V41C31.6569 41 33 39.6569 33 38H31ZM31 12V38H33V12H31ZM32.7071 11.2929L20.7071 -0.707107L19.2929 0.707107L31.2929 12.7071L32.7071 11.2929ZM4 1H20V-1H4V1Z'
      fill='#D7D4D5'
      mask='url(#path-1-inside-1_78_39869)'
    />
    <path d='M32 12L22 12C20.8954 12 20 11.1046 20 10L20 0L32 12Z' fill='#D7D4D5' />
    <rect y='20' width='28' height='12' rx='2' fill='#00796B' />
    <path
      d='M7.58057 27.1138H5.91504V26.2393H7.58057C7.87061 26.2393 8.10498 26.1924 8.28369 26.0986C8.4624 26.0049 8.59277 25.876 8.6748 25.7119C8.75977 25.5449 8.80225 25.3545 8.80225 25.1406C8.80225 24.9385 8.75977 24.7495 8.6748 24.5737C8.59277 24.395 8.4624 24.2515 8.28369 24.1431C8.10498 24.0347 7.87061 23.9805 7.58057 23.9805H6.25342V29.5H5.15039V23.1016H7.58057C8.07568 23.1016 8.49609 23.1895 8.8418 23.3652C9.19043 23.5381 9.45557 23.7783 9.63721 24.0859C9.81885 24.3906 9.90967 24.7393 9.90967 25.1318C9.90967 25.5449 9.81885 25.8994 9.63721 26.1953C9.45557 26.4912 9.19043 26.7183 8.8418 26.8765C8.49609 27.0347 8.07568 27.1138 7.58057 27.1138ZM15.9741 23.1016V29.5H14.8711L12.0015 24.9165V29.5H10.8984V23.1016H12.0015L14.8799 27.6938V23.1016H15.9741ZM22.2012 26.2305V28.6738C22.1104 28.7939 21.9683 28.9258 21.7749 29.0693C21.5845 29.21 21.3311 29.3315 21.0146 29.4341C20.6982 29.5366 20.3042 29.5879 19.8325 29.5879C19.4312 29.5879 19.0635 29.5205 18.7295 29.3857C18.3955 29.248 18.1069 29.0474 17.8638 28.7837C17.6235 28.52 17.4375 28.1992 17.3057 27.8213C17.1738 27.4404 17.1079 27.0068 17.1079 26.5205V26.0767C17.1079 25.5933 17.168 25.1626 17.2881 24.7847C17.4111 24.4038 17.5869 24.0815 17.8154 23.8179C18.0439 23.5542 18.3193 23.355 18.6416 23.2202C18.9668 23.0825 19.3345 23.0137 19.7446 23.0137C20.269 23.0137 20.7026 23.1016 21.0454 23.2773C21.3911 23.4502 21.6577 23.6904 21.8452 23.998C22.0327 24.3057 22.1514 24.6572 22.2012 25.0527H21.1201C21.085 24.8301 21.0161 24.6309 20.9136 24.4551C20.814 24.2793 20.6704 24.1416 20.4829 24.042C20.2983 23.9395 20.0581 23.8882 19.7622 23.8882C19.5073 23.8882 19.2832 23.9365 19.0898 24.0332C18.8965 24.1299 18.7354 24.272 18.6064 24.4595C18.4805 24.647 18.3853 24.8755 18.3208 25.145C18.2563 25.4146 18.2241 25.7222 18.2241 26.0679V26.5205C18.2241 26.8721 18.2607 27.1841 18.334 27.4565C18.4102 27.729 18.5186 27.959 18.6592 28.1465C18.8027 28.334 18.9771 28.4761 19.1821 28.5728C19.3872 28.6665 19.6187 28.7134 19.8765 28.7134C20.1284 28.7134 20.335 28.6929 20.4961 28.6519C20.6572 28.6079 20.7847 28.5566 20.8784 28.498C20.9751 28.4365 21.0498 28.3779 21.1025 28.3223V27.0522H19.771V26.2305H22.2012Z'
      fill='white'
    />
  </svg>
)

export const FileIcon: FC<FileIconProps> = ({ type, className }): ReactElement => {
  if (type === "png") return <PngIcon className={className} />

  const { text, stripeColor } = FILE_ICON_TYPE_TO_CONFIG[type]
  return <FileIconTemplate className={className} text={text} stripeColor={stripeColor} />
}
